import React from "react";


import industryBanner from "../assets/industry.png";

const styles = `
  /* ── Reset / Base ── */
  * { box-sizing: border-box; }

  /* ── Services Grid ── */
  .industry-services-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  /* ── Use Cases Grid ── */
  .industry-usecases-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  /* ── Implementation Grid ── */
  .industry-impl-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  /* ── Section Padding ── */
  .industry-section {
    padding: 60px 35px;
  }

  /* ── Hero Heading ── */
  .industry-h1 {
    font-size: 44px;
    margin-bottom: 18px;
    line-height: 1.1;
    font-family: "Exo", sans-serif;
    font-weight: 700;
  }

  /* ── CTA Heading ── */
  .industry-cta-h1 {
    font-size: 35px;
    margin-bottom: 18px;
    font-family: "Exo", sans-serif;
    line-height: 1.1;
    color: #fff;
  }

  /* ── Card ── */
  .industry-card {
    background: #fff;
    border: 2px solid #4b84d9;
    border-radius: 12px;
    padding: 24px;
    min-height: 260px;
    color: #000;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  }
  .industry-card li {
    color: #000;
  }
  .industry-card ul,
  .industry-usecase-card ul,
  .industry-impl-card ul {
    list-style: disc;
    padding-left: 22px;
    color: #000;
  }

  .industry-usecase-card {
    border: 2px solid #4b84d9;
    border-radius: 10px;
    padding: 26px;
    min-height: 250px;
    background: rgba(255, 255, 255, 0.05);
    color: #000;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  }

  .industry-impl-card {
    border: 2px solid #4b84d9;
    border-radius: 10px;
    padding: 28px;
    background: #27baa7;
    color: #000;
  }

  /* ── Card Headings ── */
  .industry-card-h2 {
    text-align: center;
    margin-bottom: 22px;
    font-size: 22px;
    color: #1f1f1f;
    font-family: "Exo", sans-serif;
    font-weight: 700;
    line-height: 1.2;
  }

  .industry-impl-h2 {
    text-align: center;
    margin-bottom: 22px;
    font-size: 23px;
    font-family: "Exo", sans-serif;
  }

  /* ── CTA Button ── */
  .industry-cta-btn {
    background: #fff;
    color: #111;
    border: none;
    padding: 14px 24px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
  }

  /* ── Banner image ── */
  .industry-banner-img {
    width: 100%;
    display: block;
    height: auto;
    object-fit: cover;
  }

  /* ── Large Desktop: 1400px+ ── */
  @media (min-width: 1400px) {
    .industry-section {
      padding: 70px 60px;
    }
    .industry-h1 {
      font-size: 50px;
    }
    .industry-cta-h1 {
      font-size: 40px;
    }
    .industry-services-grid {
      gap: 28px;
    }
    .industry-usecases-grid {
      gap: 28px;
    }
    .industry-impl-grid {
      gap: 28px;
    }
    .industry-card {
      padding: 30px;
    }
    .industry-usecase-card {
      padding: 30px;
    }
    .industry-impl-card {
      padding: 34px;
    }
    .industry-card-h2 {
      font-size: 24px;
    }
    .industry-impl-h2 {
      font-size: 25px;
    }
  }

  /* ── Tablet Landscape / Small Desktop: 1024px – 1199px ── */
  @media (max-width: 1199px) and (min-width: 1024px) {
    .industry-section {
      padding: 55px 30px;
    }
    .industry-h1 {
      font-size: 40px;
    }
    .industry-cta-h1 {
      font-size: 32px;
    }
    .industry-card {
      padding: 22px;
    }
    .industry-usecase-card {
      padding: 22px;
    }
    .industry-impl-card {
      padding: 26px;
    }
    .industry-card-h2 {
      font-size: 20px;
    }
    .industry-impl-h2 {
      font-size: 21px;
    }
  }

  /* ── Tablet: 768px – 1023px ── */
  @media (max-width: 1023px) {
    .industry-services-grid {
      grid-template-columns: repeat(2, 1fr);
    }
    .industry-usecases-grid {
      grid-template-columns: repeat(2, 1fr);
    }
    .industry-impl-grid {
      grid-template-columns: repeat(2, 1fr);
    }
    .industry-h1 {
      font-size: 36px;
    }
    .industry-cta-h1 {
      font-size: 28px;
    }
  }

  /* ── Tablet Portrait: 768px – 1023px ── */
  @media (max-width: 1023px) and (min-width: 768px) {
    .industry-section {
      padding: 50px 28px;
    }
    .industry-card {
      padding: 22px;
      min-height: 230px;
    }
    .industry-usecase-card {
      padding: 22px;
      min-height: 220px;
    }
    .industry-impl-card {
      padding: 24px;
    }
    .industry-card-h2 {
      font-size: 20px;
      margin-bottom: 18px;
    }
    .industry-impl-h2 {
      font-size: 21px;
    }
    .industry-cta-btn {
      padding: 13px 22px;
    }
  }

  /* ── Mobile: up to 767px ── */
  @media (max-width: 767px) {
    .industry-services-grid {
      grid-template-columns: 1fr;
    }
    .industry-usecases-grid {
      grid-template-columns: 1fr;
    }
    .industry-impl-grid {
      grid-template-columns: 1fr;
    }
    .industry-section {
      padding: 40px 18px;
    }
    .industry-h1 {
      font-size: 28px;
      margin-bottom: 14px;
    }
    .industry-cta-h1 {
      font-size: 24px;
    }
    .industry-card {
      min-height: unset;
      padding: 20px;
    }
    .industry-usecase-card {
      min-height: unset;
      padding: 20px;
    }
    .industry-impl-card {
      padding: 22px;
    }
    .industry-card-h2 {
      font-size: 19px;
    }
    .industry-impl-h2 {
      font-size: 20px;
    }
    .industry-cta-btn {
      width: 100%;
      text-align: center;
      padding: 14px 18px;
    }
  }

  /* ── Large Mobile: 481px – 767px (2-col grid for cards) ── */
  @media (max-width: 767px) and (min-width: 481px) {
    .industry-services-grid {
      grid-template-columns: repeat(2, 1fr);
    }
    .industry-usecases-grid {
      grid-template-columns: repeat(2, 1fr);
    }
    .industry-impl-grid {
      grid-template-columns: repeat(2, 1fr);
    }
    .industry-section {
      padding: 44px 22px;
    }
    .industry-h1 {
      font-size: 30px;
    }
    .industry-cta-h1 {
      font-size: 26px;
    }
    .industry-card-h2 {
      font-size: 17px;
      margin-bottom: 14px;
    }
    .industry-impl-h2 {
      font-size: 18px;
    }
    .industry-cta-btn {
      width: auto;
    }
  }

  /* ── Small Mobile: up to 480px ── */
  @media (max-width: 480px) {
    .industry-services-grid {
      grid-template-columns: 1fr;
      gap: 14px;
    }
    .industry-usecases-grid {
      grid-template-columns: 1fr;
      gap: 14px;
    }
    .industry-impl-grid {
      grid-template-columns: 1fr;
      gap: 14px;
    }
    .industry-section {
      padding: 36px 16px;
    }
    .industry-h1 {
      font-size: 26px;
      margin-bottom: 12px;
    }
    .industry-cta-h1 {
      font-size: 22px;
    }
    .industry-card {
      padding: 18px;
    }
    .industry-usecase-card {
      padding: 18px;
    }
    .industry-impl-card {
      padding: 20px;
    }
    .industry-card-h2 {
      font-size: 17px;
      margin-bottom: 14px;
    }
    .industry-impl-h2 {
      font-size: 18px;
      margin-bottom: 16px;
    }
  }

  /* ── Extra Small Mobile: up to 400px ── */
  @media (max-width: 400px) {
    .industry-h1 {
      font-size: 23px;
    }
    .industry-cta-h1 {
      font-size: 20px;
    }
    .industry-section {
      padding: 32px 14px;
    }
    .industry-card {
      padding: 16px;
    }
    .industry-usecase-card {
      padding: 16px;
    }
    .industry-impl-card {
      padding: 18px;
    }
    .industry-card-h2 {
      font-size: 16px;
    }
    .industry-impl-h2 {
      font-size: 17px;
    }
  }

  /* ── Very Small Phones: up to 360px ── */
  @media (max-width: 360px) {
    .industry-h1 {
      font-size: 21px;
    }
    .industry-cta-h1 {
      font-size: 18px;
    }
    .industry-section {
      padding: 28px 12px;
    }
    .industry-card-h2 {
      font-size: 15px;
    }
    .industry-impl-h2 {
      font-size: 16px;
    }
  }

  /* ── Ultra-wide / TV: 1920px+ ── */
  @media (min-width: 1920px) {
    .industry-section {
      padding: 80px 100px;
      max-width: 2200px;
      margin-left: auto;
      margin-right: auto;
    }
    .industry-h1 {
      font-size: 56px;
    }
    .industry-cta-h1 {
      font-size: 46px;
    }
    .industry-services-grid {
      gap: 32px;
    }
    .industry-usecases-grid {
      gap: 32px;
    }
    .industry-impl-grid {
      gap: 32px;
    }
    .industry-card {
      padding: 36px;
    }
    .industry-usecase-card {
      padding: 36px;
    }
    .industry-impl-card {
      padding: 40px;
    }
    .industry-card-h2 {
      font-size: 26px;
    }
    .industry-impl-h2 {
      font-size: 28px;
    }
  }
`;

function IndustryPage() {
  const services = [
    {
      title: "Consulting & Strategy",
      points: [
        "AI adoption roadmaps & value discovery",
        "Business process automation consulting",
        "Data strategy & AI readiness assessment",
        "Custom solution design for shop‑floor & enterprise",
        "LLM testing & validation strategies",
      ],
    },
    {
      title: "AI‑Powered Software Development",
      points: [
        "Custom AI/ML models: predictive maintenance, demand forecasting, QA",
        "Integration with MES/ERP/SCADA",
        "End‑to‑end AI application development",
        "Custom GPTs & virtual assistants (operator guidance, safety)",
        "Document processing & AI‑powered knowledge search",
        "Vision AI: defect detection, classification, traceability",
      ],
    },
    {
      title: "LLM Services",
      points: [
        "Custom LLM development & fine‑tuning",
        "Instruction‑tuning for task‑specific performance",
        "RAG pipelines for technical docs & maintenance support",
        "Enterprise LLM solutions with governance & observability",
      ],
    },
    {
      title: "Data Intelligence",
      points: [
        "Production analytics & OEE dashboards",
        "Performance & energy analytics",
        "Maintenance analytics (predictive & prescriptive)",
        "Quality analytics & SPC",
        "Executive KPI boards",
      ],
    },
    {
      title: "Co‑Innovation & CoE",
      points: [
        "Research on technology & market trends",
        "Use‑case discovery, solution definition",
        "PoCs & pilots with impact analysis",
        "Partner ecosystem acceleration",
      ],
    },
    {
      title: "Managed Services",
      points: [
        "Operations transition & service model setup",
        "SLA definition, compliance & reporting",
        "24×7 operations monitoring",
        "Continuous improvement & cost optimization",
      ],
    },
  ];

  const useCases = [
    {
      title: "Predictive Maintenance",
      desc: "Detect anomalies early using sensor & historian data. Prioritize work orders, plan spares and reduce MTTR.",
      points: [
        "Vibration/thermal anomaly detection",
        "Remaining useful life (RUL) models",
        "Maintenance copilots for technicians",
      ],
    },
    {
      title: "Quality Inspection (Vision AI)",
      desc: "Automated visual inspection for defects & dimensional checks—online or end-of-line",
      points: [
        "Defect detection & classification",
        "Traceability & lot genealogy",
        "Real-time SPC alerts",
      ],
    },
    {
      title: "Production Optimization",
      desc: "Digital twins & analytics to balance lines, reduce changeovers and improve yield.",
      points: [
        "OEE dashboards & bottleneck analysis",
        "Scheduling & line balancing",
        "Energy & throughput optimization",
      ],
    },
    {
      title: "Connected Workforce",
      desc: "LLM copilots for SOPs, safety, troubleshooting and training—multi-language, voice-enabled.",
      points: [
        "Instructional GPTs for operators",
        "Hands-free voice assistants",
        "Knowledge search on docs & logs",
      ],
    },
    {
      title: "Supply & Inventory",
      desc: "Forecasting, reorder automation, vendor performance analytics and GRN-to-invoice reconciliation.",
      points: [
        "Demand & spare parts forecasting",
        "Inventory optimization",
        "Procurement bots & reconciliations",
      ],
    },
    {
      title: "Safety & Compliance",
      desc: "Computer vision & sensors for PPE compliance, geofencing, near-miss analytics and audits.",
      points: [
        "PPE & zone monitoring",
        "Incident analytics",
        "Digital audit trails",
      ],
    },
  ];

  return (
    <div>
      {/* Inject responsive styles */}
      <style>{styles}</style>


      {/* ── HERO ── */}
      <div style={{ width: "100%", background: "#2fb7a4" }}>
        <img
          src={industryBanner}
          alt="Industry Banner"
          className="industry-banner-img"
        />
      </div>

      {/* ── SERVICES ── */}
      <div className="industry-section" style={{ background: "#f3f5f9" }}>
        <p
          style={{
            color: "#4b84d9",
            fontWeight: "600",
            marginBottom: "10px",
            fontSize: "14px",
            fontFamily: "Exo, sans-serif",
          }}
        >
          Offerings
        </p>

        <h1
          className="industry-h1"
          style={{ color: "#1f1f1f", maxWidth: "950px" }}
        >
          End-to-End Services for Smart Manufacturing
        </h1>

        <p
          style={{
            fontSize: "16px",
            lineHeight: "1.9",
            marginBottom: "45px",
            color: "#1e2a3b",
            fontWeight: "500",
            letterSpacing: "0.1px",
            maxWidth: "1450px",
          }}
        >
          Built on our AI Center of Excellence, we bring consulting, product
          engineering and managed services together to deliver measurable impact
          on yield, throughput and cost.
        </p>

        <div className="industry-services-grid">
          {services.map((service, i) => (
            <div key={i} className="industry-card">
              <h2 className="industry-card-h2">{service.title}</h2>
              <ul
                style={{
                  lineHeight: "1.8",
                  paddingLeft: "22px",
                  fontSize: "15px",
                  margin: 0,
                }}
              >
                {service.points.map((point, idx) => (
                  <li key={idx} style={{ marginBottom: "8px" }}>
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* ── USE CASES ── */}
      <div className="industry-section" style={{ background: "#27baa7" }}>
        <p
          style={{
            color: "#dff7ff",
            fontWeight: "600",
            marginBottom: "10px",
            fontSize: "14px",
            fontFamily: "Exo, sans-serif",
          }}
        >
          Use Cases
        </p>

        <h1
          className="industry-h1"
          style={{ color: "#111", maxWidth: "1000px", marginBottom: "40px" }}
        >
          High-Impact Smart Factory Use Cases
        </h1>

        <div className="industry-usecases-grid">
          {useCases.map((item, i) => (
            <div key={i} className="industry-usecase-card">
              <h2
                className="industry-card-h2"
                style={{ color: "#111", fontSize: "21px" }}
              >
                {item.title}
              </h2>
              <p
                style={{
                  lineHeight: "1.8",
                  marginBottom: "22px",
                  fontSize: "15px",
                }}
              >
                {item.desc}
              </p>
              <ul
                style={{
                  lineHeight: "1.8",
                  paddingLeft: "22px",
                  fontSize: "15px",
                  margin: 0,
                }}
              >
                {item.points.map((point, idx) => (
                  <li key={idx} style={{ marginBottom: "8px" }}>
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* ── IMPLEMENTATION ── */}
      <div className="industry-section" style={{ background: "#f3f5f9" }}>
        <p
          style={{
            color: "#4b84d9",
            fontWeight: "600",
            marginBottom: "10px",
            fontSize: "14px",
            fontFamily: "Exo, sans-serif",
          }}
        >
          Implementation
        </p>

        <h1
          className="industry-h1"
          style={{ color: "#111", marginBottom: "35px" }}
        >
          How We Engage
        </h1>

        <div className="industry-impl-grid">
          <div className="industry-impl-card">
            <h2 className="industry-impl-h2">Discover → Pilot → Scale</h2>
            <p
              style={{
                lineHeight: "1.8",
                marginBottom: "22px",
                fontSize: "15px",
              }}
            >
              Start with value discovery and a 4–6 week pilot to prove ROI.
              Then scale across plants with our CoE playbook.
            </p>
            <ul
              style={{
                lineHeight: "1.8",
                paddingLeft: "22px",
                fontSize: "15px",
              }}
            >
              <li>Use-case discovery & business case</li>
              <li>PoC/Pilot with success criteria</li>
              <li>Secure integration & MLOps</li>
              <li>Rollout with change management</li>
            </ul>
          </div>

          <div className="industry-impl-card">
            <h2 className="industry-impl-h2">Governed, Secure, Observable</h2>
            <p
              style={{
                lineHeight: "1.8",
                marginBottom: "22px",
                fontSize: "15px",
              }}
            >
              Enterprise-grade delivery with model governance, data privacy,
              monitoring and cost control.
            </p>
            <ul
              style={{
                lineHeight: "1.8",
                paddingLeft: "22px",
                fontSize: "15px",
              }}
            >
              <li>Model & data governance</li>
              <li>Observability & drift monitoring</li>
              <li>Cost/perf dashboards & SLAs</li>
              <li>Ops runbooks & 24×7 support</li>
            </ul>
          </div>
        </div>
      </div>

      {/* ── CTA ── */}
      <div
        className="industry-section"
        style={{
          background: "linear-gradient(180deg,#27baa7,#1d3f7d)",
        }}
      >
        <h1 className="industry-cta-h1">Ready to build a smarter factory?</h1>

        <p
          style={{
            color: "#fff",
            fontSize: "15px",
            marginBottom: "32px",
            lineHeight: "1.7",
            maxWidth: "900px",
          }}
        >
          Let's co‑create pilots that deliver ROI in weeks, then scale across
          your plants.
        </p>

        <button
          className="industry-cta-btn"
          onClick={() =>
            document
              .getElementById("siteFooter")
              ?.scrollIntoView({ behavior: "smooth" })
          }
        >
          Talk to our experts
        </button>
      </div>
    </div>
  );
}

export default IndustryPage;
